import Vue from "vue";
import RepositoryResponse from "@/interfaces/Repository/RepositoryResponse";
import { getRepositoryResponse } from "@/helpers/Repositories/RepositoryHelpers";
import Prepaid from "@/interfaces/Contracts/Prepaid";
import PrepaidPurchaseSummary from "@/interfaces/Contracts/PrepaidPurchaseSummary";
import PrepaidTransaction from "@/interfaces/Contracts/PrepaidTransaction";
import PrepaidsRepoFilter from "@/interfaces/Repository/Contracts/PrepaidsRepoFilter";
import Report from "@/interfaces/Reports/Report";

const END_POINT = "api/customerPortal/v1/prepaids";

export async function getPrepaids(
  filter: PrepaidsRepoFilter
): Promise<RepositoryResponse> {
  let repositoryResponse = {} as RepositoryResponse;

  const getRequestParameters = {
    status: filter.status,
    fromEnteredDate: filter.fromEnteredDate,
    toEnteredDate: filter.toEnteredDate,
    fromExpireDate: filter.fromExpireDate,
    toExpireDate: filter.toExpireDate,
  };

  await getRepositoryResponse(END_POINT, getRequestParameters).then(
    (response) => (repositoryResponse = response)
  );

  return repositoryResponse;
}

export async function getPrepaid(prepaidId: string): Promise<Prepaid> {
  const response = await Vue.axios.get(`${END_POINT}/${prepaidId}`);

  return response.data as Prepaid;
}

export async function getPrepaidTransactions(
  prepaidId: string
): Promise<PrepaidTransaction[]> {
  const response = await Vue.axios.get(
    `${END_POINT}/transactions/${prepaidId}`
  );

  return response.data as PrepaidTransaction[];
}

export async function getPrepaidSummaries(
  prepaidId: string
): Promise<PrepaidPurchaseSummary[]> {
  const response = await Vue.axios.get(`${END_POINT}/summaries/${prepaidId}`);
  return response.data as PrepaidPurchaseSummary[];
}

export async function getPrepaidReport(prepaidId: string): Promise<Report> {
  const response = await getRepositoryResponse(
    `${END_POINT}/${prepaidId}/report`
  );
  return response.data;
}
